import { ref } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { Themes } from '@/constants/theme'
import { Languages } from '@/constants/languages'
import { daisukeAuth0Store } from '@tsyl/daisuke-auth-plugin'
import type { Auth0User } from '@tsyl/daisuke-auth-plugin/dist/types'
import type { UserMetadata } from '#/domain/user/User'
import { useI18n } from 'vue-i18n'
import { setLang } from '@tsyl/radon'

export const useUserConfigStore = defineStore('userConfiguration', () => {
  const { locale } = useI18n()
  const daisuke = daisukeAuth0Store()
  const { user } = storeToRefs(daisuke)

  const configuration = ref<Required<UserMetadata>>({
    Theme: hasTheme(user?.value) ? user?.value?.user_metadata?.theme : Themes.Light,
    Language: hasLanguage(user?.value) ? user?.value?.user_metadata?.language : Languages.EN,
  })

  useUserConfigStore().$subscribe((mutation, state) => {
    locale.value = state.configuration.Language
    setLang(state.configuration.Language)
  })

  return { configuration }
})

function hasTheme(user: Auth0User | undefined): boolean {
  return !!user?.user_metadata?.theme
}

function hasLanguage(user: Auth0User | undefined): boolean {
  return !!user?.user_metadata?.language
}
